import { CanDeactivateFn } from "@angular/router";
import { ErrorPage } from "./error-page";

export const errorPageLeave: CanDeactivateFn<ErrorPage> = () => false;
